import {ExternalLinkIcon} from '@heroicons/react/solid'
import React from "react";
import cs from "classnames";

export type InputProps = {
    inputId: string
    className?: string
    placeholder?: string
    defaultValue?: string
    icon?: React.ReactNode;
    onChange: (link: string) => void,
    value: string


}
export default function Input({inputId, icon, defaultValue, placeholder, className, onChange, value}: InputProps) {
    return (
        <div className={className}>
            <div className="h-full relative rounded-md shadow-sm">
                {icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    {icon}
                </div>
                }
                <input
                    defaultValue={defaultValue}
                    value={value}
                    onChange={(event) => {
                        if (onChange) {
                            onChange(event.target.value)
                        }
                    }}
                    type="text"
                    name={inputId}
                    id={inputId}
                    autoComplete={"off"}
                    className={cs(
                        "h-full block w-full text-sm",
                        "pl-10 pr-5",
                        "border-gray-300 rounded-md")}
                    placeholder={placeholder}
                />
            </div>
        </div>
    )
}